jQuery.feature_import("js-day-menu-information",
  () => require("./day-menu-information.js"),
  mod => mod.feature_js_day_menu_information
);